import React, { useRef } from "react";
import { TextField } from "@mui/material";
import { inputStyles } from "./styles/inputStyles";

const MeetingDescription = ({ handleChange, eventData }) => {
    const description = eventData.description;
    const textFieldRef = useRef(null);

    const handleFocus = () => {
        // Get the input element from the TextField
        const input = textFieldRef.current.querySelector("textarea");
        if (input) {
            // Set the cursor position to the end of the text
            const length = input.value.length;
            input.setSelectionRange(length, length);
        }
    };

    return (
        <TextField
            variant="filled"
            label="Ajouter une description"
            name="description"
            value={description}
            onChange={(e) => handleChange(e)}
            ref={textFieldRef}
            fullWidth
            multiline
            minRows={1} // Start with just 1 row
            maxRows={6}
            onFocus={handleFocus}
            sx={inputStyles}
        />
    );
};

export default MeetingDescription;
